import styled from 'styled-components';

export const TutorialListWidgetCardsStyled = styled.div`
    display: flex;
    gap: 8px;
    overflow-x: scroll;

    &.mobile {
        padding: 0 16px;
        margin: 0 -16px;
    }

    &.lg {
        gap: 12px;
    }
`;

export const TutorialListWidgetHeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    color: var(--color-label-secondary);
`;

interface ITutorialListWidgetCardStyledProps {
    imgUrl: string,
}

export const TutorialListWidgetCardStyled = styled.div<ITutorialListWidgetCardStyledProps>`
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    align-items: center;
    overflow-x: scroll;
    height: 78px;
    width: 140px;
    border-radius: 12px;
    background: url(${props => props.imgUrl}) no-repeat center / cover;
    
    &.lg {
        border-radius: 10px;
        height: 120px;
        width: 204px;
    }
    
    &.is-seen {
        background: linear-gradient(0deg, var(--color-surface-50), var(--color-surface-50)), url(${props => props.imgUrl}) no-repeat center / cover;
    }
`;

export const TutorialListWidgetItemInfoStyled = styled.div`
    display: flex;
    align-items: start;
    margin-top: 12px;
    gap: 8px;
`;

export const TutorialListWidgetItemTitleStyled = styled.div`
    font-size: 14px;
    color: var(--text-color-secondary);
    padding: 0 8px;
`;

export const TutorialListWidgetCardsScrollerStyled = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    transform: translateY(calc(-50% - 2px));
    display: flex;
    justify-content: space-between;
    align-items: center;
`;